import { css } from '@emotion/react';
import React from 'react';

import CustomLink from '@/src/shared/components/Link';

import HeaderSection from '../HeaderSection';
import CommitteeList from './components/CommitteeList';

const styles = {
  committeesContainer: css`
    padding: 2.6rem 2.4rem;
  `,
};

function MyCommittees({ user }) {
  const accountManagerName = user.AccountManager;
  const accountManagerEmail = (
    <CustomLink href={`mailto:${user.AccountManagerEmail}`}>{user.AccountManagerEmail}</CustomLink>
  );

  return (
    <div css={styles.committeesContainer}>
      <HeaderSection headerText="My Committees" />
      {accountManagerName !== '' && (
        <p>
          You belong to the following committees. To leave or join a committee, please contact your
          Account Manager, {accountManagerName}, at {accountManagerEmail}.
        </p>
      )}
      <CommitteeList committees={user.Committees} />
    </div>
  );
}

export default MyCommittees;
